import { Card } from 'seagull';
import { AddTimeActivityButton } from "./AddTimeActivity";
import styles from "./TimeActivityCard.module.scss";
import { TimeActivityDetails } from "./TimeActivityDetails/TimeActivityDetails";
import { TimeActivityExternalLink } from "./TimeActivityExternalLink";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TimeActivityCard = _ref => {
  let {
    timeActivity,
    handleAddSingleTimeActivity
  } = _ref;
  return /*#__PURE__*/_jsx(Card, {
    testId: "time-activity-".concat(timeActivity.id),
    className: styles.card,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx(TimeActivityDetails, {
        timeActivity: timeActivity
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.actions,
        children: [/*#__PURE__*/_jsx(TimeActivityExternalLink, {
          timeActivity: timeActivity
        }), /*#__PURE__*/_jsx(AddTimeActivityButton, {
          timeActivity: timeActivity,
          onClick: handleAddSingleTimeActivity
        })]
      })]
    })
  }, timeActivity.id);
};